module.exports = __webpack_public_path__ + "img/lti-progress-logo.1f7d87c0.png";